import React from 'react';
import { CardProps } from '../../types';

/**
 * Card component with multiple variants and states
 * 
 * @param {CardProps} props - Card component props
 * @returns {JSX.Element} Card component
 * 
 * @example
 * <Card title="Card Title" subtitle="Card subtitle">
 *   <p>Card content goes here</p>
 * </Card>
 */
export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  header,
  footer,
  hover = false,
  className,
  children,
}) => {
  const baseClasses = 'bg-white rounded-lg shadow-sm border border-agentic-gray-200 p-6';
  const hoverClasses = hover ? 'hover:shadow-md transition-shadow duration-300 ease-agentic' : '';

  return (
    <div className={`${baseClasses} ${hoverClasses} ${className || ''}`}>
      {header && (
        <div className="mb-4">
          {header}
        </div>
      )}
      
      {(title || subtitle) && (
        <div className="mb-4">
          {title && (
            <h3 className="text-xl font-semibold text-agentic-text-primary">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="text-sm text-agentic-text-secondary mt-1">
              {subtitle}
            </p>
          )}
        </div>
      )}
      
      <div className="text-agentic-text-primary">
        {children}
      </div>
      
      {footer && (
        <div className="mt-4 pt-4 border-t border-agentic-gray-200">
          {footer}
        </div>
      )}
    </div>
  );
};

